enum ResidencyStatusEnum {
    Resident = 'RESIDENT',
    NonResident = 'NON_RESIDENT',
}

export default ResidencyStatusEnum;